import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, computed, signal } from '@angular/core';
import { ProgressComponent, WidgetStatBComponent } from '@coreui/angular-pro';
import { IUtilisationDepot } from '../../models/vehicle-status.model';

@Component({
  selector: 'app-current-utilisation-score-widget',
  standalone: true,
  changeDetection:  ChangeDetectionStrategy.OnPush,
  imports: [
    WidgetStatBComponent,
    ProgressComponent,
  ],
  templateUrl: './current-utilisation-score-widget.component.html',
  styleUrl: './current-utilisation-score-widget.component.scss'
})
export class CurrentUtilisationScoreWidgetComponent {
  @Input() title: string =  'Title';
  @Input() subTitle: string =  'Sub Title';
  @Input() set snapshot(value: IUtilisationDepot) {
    if (value) {
      // utilized_count /total_count * 100
      const calc = (value.utilized_count / value.total_count * 100).toFixed(2);
      this.valuePercent = `${calc}%`;
      this.value.set(Number(calc));
      this.cdr.detectChanges();
    }
  }

  value = signal<number>(0);


  valuePercent = '';

  constructor(private cdr: ChangeDetectorRef) {

  }
}
